import { render, staticRenderFns } from "./DiseñoProveedores.vue?vue&type=template&id=109148d8&"
import script from "./DiseñoProveedores.vue?vue&type=script&lang=js&"
export * from "./DiseñoProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports